<template>
  <div>
    <slot></slot>
    <button
      v-if="hasManyItems"
      class="btn btn-sm btn-primary-link ml-n1 mt-1"
      @click="toggleVisibility"
    >
      {{ this.isOpen ? this.show_less : this.show_more }}
    </button>
  </div>
</template>

<script>
export default {
  name: "StoreFacet_Wrapper",
  props: {
    max_visible: {
      required: false,
      type: Number,
      default: 10,
    },
    show_more: {
      required: true,
      type: String,
    },
    show_less: {
      required: true,
      type: String,
    },
  },
  data() {
    return {
      isOpen: false,
      items: this.$slots.default,
      hasManyItems: this.$slots.default ? this.$slots.default.length > this.max_visible : false,
    };
  },
  computed: {
    overflowingItems() {
      if (this.$slots.default) {
        return this.$slots.default.slice(this.max_visible, this.$slots.default.length);
      }
    },
  },
  mounted() {
    this.hideOverflowingItems();
  },
  methods: {
    hideOverflowingItems() {
      if (this.$slots.default) {
        this.overflowingItems.forEach(item => {
          item.componentInstance.visible = false;
        });
      }
    },
    setAllVisible() {
      this.items.forEach(item => {
        item.componentInstance.visible = true;
      });
    },
    toggleVisibility() {
      this.isOpen ? this.hideOverflowingItems() : this.setAllVisible();
      this.isOpen = !this.isOpen;
    },
  },
};
</script>
